import request from "@/utils/request.js";

/**
 * 被邀请加入机构
 * @param params
 * @returns {AxiosPromise}
 */
export function userJoinOrg(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/userJoinOrg",
    method: "post",
    data: params
  });
}

/**
 * 加入机构
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserAuditPassStatus(params) {
  return request({
    url: "/userService/api/app/userNurseCertificateApp/getUserAuditPassStatus",
    method: "post",
    data: params
  });
}

/**
 * 用户主动申请加入机构
 * @param params
 * @returns {AxiosPromise}
 */
export function userApplyOrg(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/userApplyOrg",
    method: "post",
    data: params
  });
}
